import React from 'react';
import { Satellite, Video, Smartphone, QrCode } from 'lucide-react';
import { technologies } from '../data/mock';

export const Technology = () => {
  const iconMap = {
    Satellite: Satellite,
    Video: Video,
    Smartphone: Smartphone,
    QrCode: QrCode
  };

  return (
    <section className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <div className="inline-block px-4 py-2 bg-blue-500/20 text-blue-300 rounded-full text-sm font-semibold border border-blue-400/30">
            Technology & Innovation
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Powered by Advanced Technology
          </h2>
          <p className="text-lg text-slate-300 max-w-3xl mx-auto">
            Leveraging cutting-edge technology for enhanced security, monitoring, and service delivery
          </p>
        </div>

        {/* Technology Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {technologies.map((tech) => {
            const Icon = iconMap[tech.icon];
            return (
              <div
                key={tech.id}
                className="group bg-slate-800/50 backdrop-blur-sm p-6 rounded-2xl border border-slate-700 hover:border-blue-500 transition-all duration-300 hover:bg-slate-800"
              >
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg shadow-blue-500/50">
                  <Icon className="w-7 h-7 text-white" />
                </div>

                {/* Content */}
                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">
                  {tech.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-sm">
                  {tech.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom Features */}
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          <div className="text-center p-6 bg-slate-800/30 rounded-xl border border-slate-700">
            <div className="text-3xl font-bold text-blue-400 mb-2">24/7</div>
            <div className="text-slate-300">Real-time Monitoring</div>
          </div>
          <div className="text-center p-6 bg-slate-800/30 rounded-xl border border-slate-700">
            <div className="text-3xl font-bold text-blue-400 mb-2">GPS</div>
            <div className="text-slate-300">Enabled Tracking</div>
          </div>
          <div className="text-center p-6 bg-slate-800/30 rounded-xl border border-slate-700">
            <div className="text-3xl font-bold text-blue-400 mb-2">QR</div>
            <div className="text-slate-300">PTR Rounds</div>
          </div>
        </div>
      </div>
    </section>
  );
};
